import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import {
  selectItemById,
  selectItemsIds,
  sendRequest,
  changeQueryParams,
  selectRequestState,
  selectPagination,
  selectQueryParams,
  changeDefaultQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import PaginationBlock from '../../../Common/Pagination/PaginationBlock/PaginationBlock';
import UserDaysStatTable1Item from './UserDaysStatTable1Item';
import DateRangeInput from '../../../Common/Inputs/DateRangeInput/DateRangeInput';
import GroupByTypesSelect from '../inputs/GroupByTypesSelect';
import OpacityPreLoader from '../../../Common/PreLoaders/OpacityPreLoader';

class UserDaysStatTable1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultQueryParams: {
        page: 1,
        group_by: null,
        dateFrom: null,
        dateTo: null
      }
    };
    this.props.changeDefaultQueryParams(this.state.defaultQueryParams);
    this.props.sendRequest();
  }

  render() {
    let items = null;
    if (this.props.itemsIds.length > 0) {
      items = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            <UserDaysStatTable1Item
              key={`UserDaysStatTable1Item${itemId}`}
              item={this.props.selectItemById(itemId)}
            />
          ))}
        </React.Fragment>
      );
    } else {
      items = (
        <tr>
          <td className="text-center" colSpan="8">
            {t('Записи не найдены')} :-(
          </td>
        </tr>
      );
    }
    return (
      <div>
        {this.props.requestState.inProgress ? <OpacityPreLoader /> : null}
        <form className="form-inline">
          <GroupByTypesSelect
            className={'form-group btn-group pull-right'}
            startValue={this.props.selectQueryParams.group_by}
            handleChangeValue={value => {
              this.props.changeQueryParams({
                page: 1,
                group_by: value
              });
              this.props.sendRequest();
            }}
          />
          <DateRangeInput
            startValueFrom={this.props.selectQueryParams.dateFrom}
            startValueTo={this.props.selectQueryParams.dateTo}
            idElement={`UserDaysStatTable1-dataRange`}
            handleChangeRangeValues={range => {
              this.props.changeQueryParams({
                page: 1,
                dateFrom: range.valueFrom,
                dateTo: range.valueTo
              });
              this.props.sendRequest();
            }}
          />
        </form>
        <div className="table-responsive">
          <table className="table table-th-bg table-text-center m-b-0">
            <thead>
              <tr>
                <th className="cell-default-bg cell-border-bottom" />
                <th className="cell-border cell-border-all" colSpan="2">
                  {t('Выполненные задания')}
                </th>
                <th className="cell-border cell-border-all" colSpan="2">
                  {t('Мои задания')}
                </th>
                <th
                  className="cell-border cell-border-all"
                  colSpan="2"
                  data-toggle="tooltip"
                  data-placement="top"
                  data-container="body"
                  title={t('Партнерская программа')}
                >
                  {t('Партн. программа')}
                </th>
                <th className="cell-default-bg cell-border-bottom" />
              </tr>
              <tr>
                <th className="cell-border">{t('Дата')}</th>
                <th className="cell-border cell-border-left">
                  {t('Количество')}
                </th>
                <th>{t('Заработано')}</th>
                <th className="cell-border cell-border-left">
                  {t('Количество')}
                </th>
                <th>{t('Потрачено')}</th>
                <th
                  className="cell-border cell-border-left"
                  data-toggle="tooltip"
                  data-placement="top"
                  data-container="body"
                  title={t('Количество новых регистрация')}
                >
                  {t('Регистраций')}
                </th>
                <th
                  data-toggle="tooltip"
                  data-placement="top"
                  data-container="body"
                  title={t('Заработано с партнерских отчислений')}
                >
                  {t('Заработано')}
                </th>
                <th className="cell-border cell-border-left">{t('Баланс')}</th>
              </tr>
            </thead>
            <tbody>{items}</tbody>
          </table>
        </div>
        <div className="table-footer">
          <PaginationBlock
            paginationData={this.props.pagination}
            handlePageClick={pageNumber => {
              this.props.changeQueryParams({ page: pageNumber });
              this.props.sendRequest();
            }}
          />
        </div>
      </div>
    );
  }
}

UserDaysStatTable1.contextTypes = {
  router: PropTypes.shape()
};

UserDaysStatTable1.propTypes = {
  changeDefaultQueryParams: PropTypes.func.isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectItemById: PropTypes.func.isRequired,
  selectQueryParams: PropTypes.shape({
    group_by: PropTypes.string,
    dateFrom: PropTypes.string,
    dateTo: PropTypes.string
  }).isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,

  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  requestStatusData: selectRequestState(state, props.listReduceName),
  pagination: selectPagination(state, props.listReduceName),
  itemsIds: selectItemsIds(state, props.listReduceName),
  selectItemById: id => selectItemById(state, props.listReduceName, id),
  selectQueryParams: selectQueryParams(state, props.listReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeDefaultQueryParams: queryParams =>
    dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDaysStatTable1);



// WEBPACK FOOTER //
// ./src/components/UserDaysStat/UserDaysStatTables/UserDaysStatTable1/UserDaysStatTable1.js